export const DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS = 'LEGITIMATE_INTEREST_PQL';
export const LEGAL_CONSENT_OPTIONS_KEY = 'legalConsentOptions';